import { render, staticRenderFns } from "./index.vue?vue&type=template&id=31ad25b0&scoped=true&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./index.vue?vue&type=style&index=1&id=31ad25b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ad25b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\opusb-web-myactio\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31ad25b0')) {
      api.createRecord('31ad25b0', component.options)
    } else {
      api.reload('31ad25b0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=31ad25b0&scoped=true&", function () {
      api.rerender('31ad25b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/layout/components/TagsView/index.vue"
export default component.exports